import { put } from 'redux-saga/effects';
import getPlacementTests from '../../../apiCalls/hub/getPlacementTests';
import { loadPlacementTestsSuccess, loadPlacementTestsFailure } from '../../../../actions/placementTests';

function* loadPlacementTests(payload) {
  const { orgId, sortBy, status } = payload;

  const response = yield getPlacementTests({ orgId, sortBy, status });
  if (response.status === 'success') {
    const { data = [] } = response;
    const structuredData = data.reduce((acc, placementTest) => {
      acc[placementTest._id] = placementTest;
      return acc;
    }, {});
    yield put(loadPlacementTestsSuccess(structuredData));
  } else {
    yield put(loadPlacementTestsFailure(response));
  }
}

export default loadPlacementTests;
